import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PlayCircle, Mic } from "lucide-react";
import { api, API } from "@/lib/site";

export const Sermons = () => {
  const [sermons, setSermons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/sermons")
      .then((r) => setSermons(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!loading && sermons.length === 0) return null;

  return (
    <section
      id="sermons"
      data-testid="sermons-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#0A0612] border-y border-[#D4AF37]/15"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-14"
        >
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] mb-5 flex items-center justify-center gap-2">
            <Mic className="h-4 w-4" /> The Word
          </p>
          <h2 className="font-display text-4xl sm:text-6xl font-semibold text-[#F9F6F0]">
            Sermons from <span className="gold-text italic">Pastor Duane Thomas</span>
          </h2>
          <p className="text-[#A19CA8] text-lg mt-6 max-w-2xl mx-auto leading-relaxed">
            Be encouraged and equipped. Watch a word from our Senior Servant as we prepare to launch.
          </p>
        </motion.div>

        {loading ? (
          <p className="text-center text-[#A19CA8]">Loading messages…</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {sermons.map((s, i) => (
              <motion.div
                key={s.id}
                data-testid="sermon-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="group bg-[#130A1F]/70 border border-[#D4AF37]/25 overflow-hidden hover:border-[#D4AF37]/60 transition-all duration-500"
              >
                <div className="relative bg-black aspect-video">
                  <video
                    data-testid={`sermon-video-${s.id}`}
                    controls
                    preload="metadata"
                    playsInline
                    className="w-full h-full object-contain"
                    src={`${API}/sermons/${s.id}/video`}
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-display text-xl text-[#F9F6F0] flex items-center gap-2">
                    <PlayCircle className="h-5 w-5 text-[#D4AF37] shrink-0" />
                    {s.title}
                  </h3>
                  {s.description && (
                    <p className="text-[#A19CA8] text-sm mt-2 leading-relaxed">{s.description}</p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
